import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Button } from "@eventbrite/valkyrie-eds-button";
import { Icon, SIZES } from "@eventbrite/valkyrie-eds-icon";

import { STYLE_NONE as BUTTON_STYLE_NONE } from "@eventbrite/valkyrie-eds-button";
import {
  STYLE_PROP_TYPE,
  ICON_PROP_TYPE,
  STYLE_NEUTRAL,
  STYLE_DARK,
} from "./constants";
import { getAdditionalProps } from "@eventbrite/valkyrie-eds-utils/props";

import styles from "./IconButton.module.scss";

export class IconButton extends PureComponent {
  static propTypes = {
    /**
     * The title used to describe icon button
     */
    title: PropTypes.string,
    /**
     * Changes the style of the icon button.
     */
    style: STYLE_PROP_TYPE,
    /**
     * The type of icon that you want to display (chunky or third party)
     */
    iconType: ICON_PROP_TYPE,
    /**
     * The className to add to icon that you want to display
     */
    iconClassName: PropTypes.string,
    /**
     * The className to add to button
     */
    buttonClassName: PropTypes.string,
    /**
     * If the icon button is active
     **/
    isActive: PropTypes.bool,
    /**
     * If the icon button should be set to a disabled state
     **/
    isDisabled: PropTypes.bool,
    /**
     * If the icon button will be shown over an image, use a style that includes a background color for better visibility
     **/
    isOverImage: PropTypes.bool,
    /**
     * Callback function invoked when the button is clicked.
     */
    onClick: PropTypes.func,
    /**
     * Overrides the color of the icon.
     */
    iconColor: PropTypes.string,
  };

  static defaultProps = {
    style: STYLE_NEUTRAL,
    isActive: false,
    isDisabled: false,
    isOverImage: false,
  };

  render() {
    const {
      style,
      title,
      isActive,
      isDisabled,
      isOverImage,
      iconType,
      onClick,
      iconColor,
      iconClassName,
      buttonClassName,
    } = this.props;

    const extraAttrs = getAdditionalProps(this);
    const iconExtraAttrs = {};

    if (buttonClassName) {
      extraAttrs.__containerClassName = buttonClassName;
    }

    if (iconClassName) {
      iconExtraAttrs.__containerClassName = iconClassName;
    }

    let buttonStyle = style;

    if (buttonStyle === STYLE_DARK) {
      buttonStyle = STYLE_NEUTRAL;
    }

    const iconButtonClasses = classNames(styles.root, {
      [styles.active]: isActive,
      [styles.disabled]: isDisabled,
      [styles.overImage]: isOverImage,
      [styles[buttonStyle]]: buttonStyle,
    });

    return (
      <span className={iconButtonClasses} data-spec="icon-button">
        <Button
          style={BUTTON_STYLE_NONE}
          onClick={onClick}
          disabled={isDisabled}
          {...extraAttrs}
        >
          <Icon
            type={iconType}
            title={title}
            isBlockLevel={true}
            color={iconColor}
            {...iconExtraAttrs}
          />
        </Button>
      </span>
    );
  }
}
